import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import { combineReducers } from "redux";
import SmartCompanyService from "services/SmartCompanyService";

let initialState = { data: {} };

export const getSmartCompany = createAsyncThunk(
  "smartCompany/getSmartCompany",
  async (smartCompanyId) => {
    const response = await SmartCompanyService.getSmartCompany(smartCompanyId);
    return response?.results;
  }
);

export const addSmartCompany = createAsyncThunk(
  "smartCompany/addSmartCompany",
  async (body, { dispatch }) => {
    const { sharedholders, ...resBody } = body;
    const shareholderBody = {
      sharedholder: sharedholders,
      smartCompanyID: resBody.smartCompanyID,
    };

    const response = await SmartCompanyService.addSmartCompany(resBody);
    await SmartCompanyService.addSmartCompanyShareholder(shareholderBody);
    await dispatch(getSmartCompany(response?.results?.smartCompanyID));
    return response?.results;
  }
);

export const uploadSmartCompanyDoc = createAsyncThunk(
  "smartCompany/uploadSmartCompanyDoc",
  async (body) => {
    const response = await SmartCompanyService.uploadSmartCompanyDoc(body);
    return response?.results;
  }
);

export const updateSmartCompanyConditionType = createAsyncThunk(
  "smartCompany/updateSmartCompanyConditionType",
  async (body) => {
    const response = await SmartCompanyService.updateSmartCompanyConditionType(
      body
    );
    return response?.results;
  }
);

const smartCompanySlice = createSlice({
  name: "smartCompany",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getSmartCompany, builder, ["data"]);
  },
});

export const addSmartCompanySlice = createSlice({
  name: "smartCompany",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(addSmartCompany, builder, ["data"]);
  },
});

export const uploadSmartCompanyDocSlice = createSlice({
  name: "smartCompany",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(uploadSmartCompanyDoc, builder, ["data"]);
  },
});

export const updateSmartCompanyConditionTypeSlice = createSlice({
  name: "smartCompany",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(updateSmartCompanyConditionType, builder, [
      "data",
    ]);
  },
});

export const selectSmartCompany = (state) => state.smartCompany.detail;
export const selectIsChamber = (state) =>
  selectSmartCompany(state)?.data?.isChamber ?? false;
export const selectAddSmartCompany = (state) => state.smartCompany.add;
export const selectUploadSmartCompanyDoc = (state) =>
  state.smartCompany.uploadSmartDoc;
export const selectUpdateSmartCompanyConditionType = (state) =>
  state.smartCompany.updateSmartCompanyConditionType;

export default combineReducers({
  detail: smartCompanySlice.reducer,
  add: addSmartCompanySlice.reducer,
  uploadSmartDoc: uploadSmartCompanyDocSlice.reducer,
  updateSmartCompanyConditionType: updateSmartCompanyConditionTypeSlice.reducer,
});
